import { Icon, IconProps } from '@chakra-ui/react';

export function FileCopyIcon(props: IconProps): JSX.Element {
  return (
    <Icon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M14.8341 15.8338H5.66748C5.20915 15.8338 4.81679 15.6706 4.4904 15.3442C4.16401 15.0178 4.00081 14.6255 4.00081 14.1671V2.50047C4.00081 2.04213 4.16401 1.64977 4.4904 1.32338C4.81679 0.996996 5.20915 0.833801 5.66748 0.833801H11.5008L16.5008 5.8338V14.1671C16.5008 14.6255 16.3376 15.0178 16.0112 15.3442C15.6848 15.6706 15.2925 15.8338 14.8341 15.8338ZM10.6675 6.66714V2.50047H5.66748V14.1671H14.8341V6.66714H10.6675ZM2.33415 19.1671C1.87581 19.1671 1.48345 19.0039 1.15706 18.6776C0.830675 18.3512 0.66748 17.9588 0.66748 17.5005V5.8338H2.33415V17.5005H11.5008V19.1671H2.33415Z" />
    </Icon>
  );
}
